import { IconAltPeople, IconFilledHome, IconSettings } from "@/assets/icons";
import { AppRoutes } from "@/routes/config";
import { TUserRole, USER_ROLE } from "@/types/enum";
import { ComponentType, SVGProps } from "react";

export type VisibleFor = "rso" | "company" | "both";

export type MenuObject = {
  text: string;
  icon?: ComponentType<SVGProps<SVGSVGElement>>;
  path?: string;
  relatedRoutes?: string[];
  visibleFor?: VisibleFor;
  allowRoles?: TUserRole[];
  section?: string;
};

export const menus: MenuObject[] = [
  {
    text: "ホーム",
    icon: IconFilledHome,
    path: AppRoutes.home,
    relatedRoutes: [AppRoutes.home],
    visibleFor: "both",
  },
  {
    text: "ユーザー管理",
    icon: IconAltPeople,
    path: AppRoutes.customerUsers,
    relatedRoutes: [AppRoutes.customerUsers, AppRoutes.customerUserCreate, AppRoutes.customerUserDetail, AppRoutes.customerUserEdit],
    visibleFor: "both",
    allowRoles: [USER_ROLE.ADMIN, USER_ROLE.MEMBER],
    section: "管理機能",
  },
  {
    text: "ユーザー設定",
    icon: IconSettings,
    path: AppRoutes.userSettingDetail,
    relatedRoutes: [AppRoutes.userSettingDetail, AppRoutes.userSettingEdit, AppRoutes.userSettingChangeEmail],
    visibleFor: "both",
    section: "その他の設定",
  },
];
